"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Thanks = require("./Thanks");
Object.keys(_Thanks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Thanks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Thanks[key];
    }
  });
});
var _constants = require("./constants");
Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _constants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constants[key];
    }
  });
});
